(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ace-places-map"] && !window.DesignMode) return;
  try {
    
    jQuery( document ).ready(function() {


      
    if (jQuery('#map').length) {
        if (jQuery('body').data('town') == 'henley' || jQuery('body').attr('id') == 'henley') {
            var map = L.map('map', {scrollWheelZoom:false}).setView([51.5391326,-0.906886], 15);
        } else {
            var map = L.map('map', {scrollWheelZoom:false}).setView([51.5653327,-0.7864001], 13);
        }

        map.on('click', function() {
            if (map.scrollWheelZoom.enabled()) {
                map.scrollWheelZoom.disable();
            }
            else if (map.scrollWheelZoom.disable()){
                map.scrollWheelZoom.enable();
            }
        });

        L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
            maxZoom: 20,
            attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
        }).addTo(map);

        markers.forEach(({title, lat, lng, iconAsset, target}) => {
            const icon = L.icon({
                iconUrl: `${iconAsset}`,
                iconSize: [32, 32],
                iconAnchor: [16, 32],
                popupAnchor: [0, -32]
            },{});
            const marker = L.marker([lat, lng], { icon }).bindPopup(title).addTo(map);
            /*marker.on('click', () => {
                window.location.href = target; // should link up with the modal logic
            });*/
        });
        }


    


jQuery(".filter-henley").click(function(){
  //alert('henley');
//setView([51.5391326,-0.906886], 15,);
  jQuery('#map').show();
          map.invalidateSize();
  map.setView([51.5391326,-0.906886], 15)
//map.panTo(new L.LatLng(51.5391326,-0.906886));
});
jQuery(".filter-marlow").click(function(){
  jQuery('#map').show();
          map.invalidateSize();
  map.setView([51.5783327,-0.7864001], 14);
//map.panTo(new L.LatLng(51.5653327,-0.7864001));
});
jQuery(".filter-clear").click(function(){
  jQuery('#map').hide();
});



      
    });

  } catch(e) { console.error(e); }
})();
})();
